import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import styled, { css } from 'styled-components';
import {Box, BoxButton, MainHeading, Divider} from '../../StyledComponents';
import { toggleTimelineActive, toggleRelevanceChart } from '../../../actions/dataAction';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import TargetSettings from './TargetSettings';

const EditButton = styled(BoxButton) `
  min-width:30px;
  float:right;
`;

const Pyramid = styled.div`
  max-width: 40%;
  margin: 0 auto;
  position: relative;
  display: block;
  height: 200px;
`

const PyramidSection = styled.div`
  background: #ad1220;
  margin: 0 auto;
  width: 10%;
  display: block;
  height: 35px;
  position: relative;
  border-top: 7px solid #000;

  &:nth-child(1) {
     clip-path: polygon(50% 0, 100% 100%, 0% 100%);
    width: 20%;
    border-top: 0;
    background: #e8b85c;
  }
  &:nth-child(2) {
    clip-path: polygon(25% 0, 75% 0, 100% 100%, 0 100%);
    width: 40%;
    background: #b51fd2;
  }
  &:nth-child(3) { 
    clip-path: polygon(16.5% 0, 83% 0, 100% 100%, 0 100%);
    width:60%;
    background: #0e67ba;
  }
  &:nth-child(4) {
    clip-path: polygon(12.5% 0, 87.5% 0, 100% 100%, 0 100%);
    width:80%;
    background: #eb5d64;
  }
  &:nth-child(5) {
    clip-path: polygon(8.5% 0, 91.5% 0, 100% 100%, 0 100%);
    width:97%;
    background: #aed5fd;
  }
`

const LegendHeadline = styled.span`
  color: #67aa9a;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: bold;

  ${props => props.secondary && css`
    color: #e9a784;
  `}
`

const LegendContainer = styled.div`
  position: absolute;
  height: 175px;
  display: flex;
  flex-direction: column;

  ${props => props.alignLeft && css`
    left: 0px;
  `}

  ${props => props.alignRight && css`
    text-align: right;
    right: 0px;
  `}
`

const LegendItem = styled.div`
  position: relative;
  flex: 1;
  top: 10px;
  min-width: 170px;

  &:nth-child(1) {
    color: #e8b85c;
  }

  &:nth-child(2) {
    color: #b51fd2;
  }

  &:nth-child(3) {
    color: #0e67ba;
  }

  &:nth-child(4) {
    color: #eb5d64;
  }

  &:nth-child(5) {
    color: #aed5fd;
  }
`

const Score = styled.div`
  float: right;
  font-weight: bold;

  ${props => props.alignLeft && css`
    float: left;
  `}
`

const PyramidContainer = styled.div`
  position: relative;
`

const ButtonContainer = styled.div`
  margin: 30px 0;
`

const modalStyleOpenDialog = {
  maxWidth: '700px',
}


class KPIPyramid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editDialogOpen: false,
    };
  }

  handleCloseEditDialog = () => {
    this.setState({editDialogOpen: false});
  };

  render() {
    const { data, user } = this.props;


    const targetArray = user.client && user.client.targetSettings;
    // Make array into object
    let targets = {};
    _.each(targetArray, function(row, i) {
      let obj = {};
      let param = '';
      _.each(row, function(col,i) {
        obj[col.type] = col.value
        if (col.type==='param') {
          param = col.value;
        }
      });
      targets[param] = obj;
    })
    const brandData = (data && data.variableData && data.variableData.brand) || {};
    const brandAwareness = brandData.awareness && brandData.awareness.yes ?  (brandData.awareness.yes + "%") : "N/A";

    const preference = data.telescope && data.telescope._data.prf && data.telescope._data.prf.perception && data.telescope._data.prf.perception.positive ? (data.telescope._data.prf.perception.positive + "%") : "N/A";


    const targetMarketShare = (targets.marketShare && targets.marketShare.target) ?  (targets.marketShare && targets.marketShare.target) + (targets.marketShare && targets.marketShare.unit) : 'N/A'
    const targetSov = (targets.shareOfVoice && targets.shareOfVoice.target) ? (targets.shareOfVoice && targets.shareOfVoice.target) + (targets.shareOfVoice && targets.shareOfVoice.unit) : 'N/A'
    const targetBrandAwe = (targets.brandAwareness && targets.brandAwareness.target) ? (targets.brandAwareness && targets.brandAwareness.target) + (targets.brandAwareness && targets.brandAwareness.unit) : 'N/A'
    const targetPref =  (targets.preference && targets.preference.target) ? (targets.preference && targets.preference.target) + (targets.preference && targets.preference.unit) : 'N/A'
    const targetTraffic = (targets.traffic && targets.traffic.target) ? (targets.traffic && targets.traffic.target) + (targets.traffic && targets.traffic.unit) : 'N/A'


    const kpiData = [
      {title: "Market share", current: "N/A", target: targetMarketShare },
      {title: "Share of voice", current: "N/A", target: targetSov},
      {title: "Brand awareness", current: brandAwareness, target: targetBrandAwe },
      {title: "Preference", current: preference, target: targetPref},
      {title: "Traffic [New visits]", current: "N/A", target: targetTraffic },
    ];

    const editDialogActions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleCloseEditDialog}
        key="cancel"
      />
    ];

    return (
      <Box>

        <MainHeading>KPI Pyramid</MainHeading>

        <ButtonContainer>
          {(user.userProfile && user.userProfile.isAdmin && (
            <EditButton
              onClick={() => this.setState({editDialogOpen: !this.state.editDialogOpen})}
              className=""
            >
                <span>&#9776;</span>
            </EditButton>
          ))||null}

          <BoxButton onClick={() => this.props.toggleRelevanceChart(true)} className="margin-right hidden-xs" primary>
            <span>Progression</span>
          </BoxButton>

          <BoxButton onClick={() => this.props.toggleTimelineActive(data.timelineActive ? false:true)} className="margin-right hidden-xs">
            <span>{/* moment(data.startDate).format("YYYY-MM-DD")} -  {*/ moment(data.endDate).format("YYYY-MM-DD")}</span>
          </BoxButton>

        </ButtonContainer>

        <div className="row">
          <div className="col-sm-6">
            <LegendHeadline>Current</LegendHeadline>
          </div>
          <div className="col-sm-6 text-right">
            <LegendHeadline secondary>Target</LegendHeadline>
          </div>
        </div>
        <Divider noTopMargin/>



        <PyramidContainer>
          <LegendContainer alignLeft>
            {_.map(kpiData, (kpi, key) => {
              return(
                <LegendItem key={key}>{kpi.title} <Score>{kpi.current}</Score></LegendItem>
              )
            })}
          </LegendContainer>

          <LegendContainer alignRight>
            {_.map(kpiData, (kpi, key) => {
              return(
                <LegendItem key={key}><Score alignLeft>{kpi.target}</Score> {kpi.title}</LegendItem>
              )
            })}
          </LegendContainer>

           <Pyramid>
              <PyramidSection>&nbsp;</PyramidSection>
              <PyramidSection>&nbsp;</PyramidSection>
              <PyramidSection>&nbsp;</PyramidSection>
              <PyramidSection>&nbsp;</PyramidSection>
              <PyramidSection>&nbsp;</PyramidSection>
           </Pyramid>

        </PyramidContainer>

        <Dialog
          title="Targets"
          modal={false}
          open={this.state.editDialogOpen}
          onRequestClose={this.handleCloseEditDialog}
          contentStyle={modalStyleOpenDialog}
        >
          <TargetSettings/>
          <div style={{ textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px' }}>
            {editDialogActions}
          </div>
        </Dialog>

      </Box>
    );

  }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid,
        data: state.data,
        user: state.user
    };
}

export default connect(mapStateToProps, {toggleTimelineActive, toggleRelevanceChart})(KPIPyramid);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/KPIPyramid.js